"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalCallback = void 0;
var react_1 = __importStar(require("react"));
var ModalCallback_module_scss_1 = __importDefault(require("./ModalCallback.module.scss"));
var CheckboxAgree_1 = require("../checkboxAgree/CheckboxAgree");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var Svg_1 = require("../svg/Svg");
var FormField_1 = require("../formField/FormField");
var FormFieldPhone_1 = require("../formFieldPhone/FormFieldPhone");
var FormFieldSelect_1 = require("../formFieldSelect/FormFieldSelect");
var FormSendButton_1 = require("../formSendButton/FormSendButton");
var selectors_1 = require("../../redux/selectors");
var react_redux_1 = require("react-redux");
var useModalCallback_1 = require("../../hook/useModalCallback");
var react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
// Проверяем, нужна ли капча
var isCaptchaEnabled = process.env.CAPTCHA_ENABLED === 'true';
var ModalCallback = function () {
    var _a;
    var dispatch = (0, react_redux_1.useDispatch)();
    var modalState = (0, react_redux_1.useSelector)(selectors_1.modalSelector).callback.modalState;
    var _b = (0, useModalCallback_1.useModalCallback)(), register = _b.register, errors = _b.errors, handleSubmit = _b.handleSubmit, onSubmit = _b.onSubmit, setValue = _b.setValue, reset = _b.reset;
    var _c = (0, react_1.useState)(null), captchaToken = _c[0], setCaptchaToken = _c[1];
    var crossHandler = function () {
        reset();
        dispatch((0, modalSlice_1.closeModal)('callback'));
    };
    var handleFormSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isCaptchaEnabled && !captchaToken) {
                        alert('Пожалуйста, подтвердите, что вы не робот.');
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, onSubmit(__assign(__assign({}, data), { captcha_token: captchaToken }))];
                case 2:
                    _a.sent();
                    crossHandler(); // Закрываем модальное окно после успешной отправки
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Ошибка отправки формы:', error_1);
                    alert('Не удалось отправить заявку. Попробуйте ещё раз.');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "".concat(ModalCallback_module_scss_1.default.modal_callback, " ").concat(modalState ? ModalCallback_module_scss_1.default.modal_callback_active : ''), onClick: crossHandler },
        react_1.default.createElement("div", { className: ModalCallback_module_scss_1.default.modal_callback__inner, onClick: function (event) { return event.stopPropagation(); } },
            react_1.default.createElement("h3", { className: ModalCallback_module_scss_1.default.modal_callback__title }, "\u041E\u0431\u0440\u0430\u0442\u043D\u044B\u0439 \u0437\u0432\u043E\u043D\u043E\u043A"),
            react_1.default.createElement("div", { className: ModalCallback_module_scss_1.default.modal_callback__content },
                react_1.default.createElement("form", { className: ModalCallback_module_scss_1.default.modal_callback__form, onSubmit: handleSubmit(handleFormSubmit) },
                    react_1.default.createElement("h4", { className: ModalCallback_module_scss_1.default.modal_callback__form_title },
                        react_1.default.createElement("span", null, "\u041E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0437\u0430\u044F\u0432\u043A\u0443, \u0438 \u043D\u0430\u0448\u0438 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u044B \u0441\u0432\u044F\u0436\u0443\u0442\u0441\u044F \u0441 \u0432\u0430\u043C\u0438 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 5 \u043C\u0438\u043D\u0443\u0442!"),
                        react_1.default.createElement(Svg_1.Cross, { className: ModalCallback_module_scss_1.default.modal_callback__cross, handler: crossHandler })),
                    react_1.default.createElement(FormField_1.FormField, { register: register('name', {
                            required: true,
                            minLength: {
                                value: 2,
                                message: 'Минимальная длина - 2 символа.',
                            },
                        }), id: "callback_name", isError: Boolean(errors.name), placeholder: "\u0424\u0418\u041E" }),
                    react_1.default.createElement(FormFieldPhone_1.FormFieldPhone, { register: register, id: "callback_phone", isError: Boolean(errors.phone) }),
                    react_1.default.createElement(FormFieldSelect_1.FormFieldSelect, { register: register('preferred_time', {
                            required: true,
                        }), fieldName: "preferred_time", isError: Boolean(errors.preferred_time), placeholder: "\u041A\u043E\u0433\u0434\u0430 \u0432\u0430\u043C \u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u044C", setFormValue: setValue, items: [
                            'Как можно скорее',
                            'с 17:00 до 18:00',
                            'с 18:00 до 19:00',
                            'с 19:00 до 20:00',
                            'с 20:00 до 21:00',
                        ] }),
                    react_1.default.createElement(CheckboxAgree_1.CheckboxAgree, { register: register('agree', { required: true }), isError: Boolean(errors.agree), id: "callback_agree" }),
                    isCaptchaEnabled && (react_1.default.createElement(react_google_recaptcha_1.default, { sitekey: (_a = process.env.REACT_APP_RECAPTCHA_SITE_KEY) !== null && _a !== void 0 ? _a : '', onChange: function (token) { return setCaptchaToken(token); } })),
                    react_1.default.createElement(FormSendButton_1.FormSendButton, { textContent: "\u041F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u044C \u043C\u043D\u0435" }))))));
};
exports.ModalCallback = ModalCallback;
